import React, { useState } from 'react'
import * as XLSX from 'xlsx';
import axios from "../../../axios"
import api from "../../../api"
import { useSnackbar } from "notistack"
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Skeleton from '@mui/material/Skeleton'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import Button from "@mui/material/Button"
import { styled } from '@mui/material/styles'
import { green } from "@mui/material/colors"
import RejectedCouponExportToExcel from './RejectedCouponExportToExcel';
const Input = styled('input')({
    display: 'none',
})
export default function BulkCoupondelete(props) {
    const [coupons, setCoupons] = useState([])
    const [fileInfo, setFileInfo] = useState({ fileName: '', fileSize: '', totalCoupon: 0 })
    const [rejectedCoupon, setRejectedCoupon] = useState([])
    const { enqueueSnackbar } = useSnackbar()

    const handleSubmit = async () => {
        if (!coupons.length) return enqueueSnackbar("Coupon list is not allowed to be empty", { variant: 'error' })
        try {
            const response = await axios.delete(api.bulkCouponDelete, {
                headers: { "x-auth-token": localStorage.getItem("user") },
                data: { coupons: coupons }
            })
            if (response?.data?.rejectedCoupon) {
                setRejectedCoupon(response?.data?.rejectedCoupon)
            }
            enqueueSnackbar("" + response.data.message, { variant: 'success' })
        } catch (error) {
            enqueueSnackbar("coupons delete failed : " + error.response.data, { variant: 'error' })
        }
    }

    const onUploadExcel = (e) => {
        e.preventDefault();
        var files = e.target.files, f = files[0];
        var fileName = e.target.files[0]?.name
        var fileSize = e.target.files[0]?.size
        var reader = new FileReader();
        reader.onload = function (e) {
            var data = e.target.result;
            let readedData = XLSX.read(data, { type: 'binary' });
            const wsname = readedData.SheetNames[0];
            const ws = readedData.Sheets[wsname];
            /* Convert array to json*/
            const dataParse = XLSX.utils.sheet_to_json(ws, { header: 0 });
            var coupons = []
            dataParse.filter(function (item) { coupons.push(item.Coupon) })
            setCoupons(coupons)
            setFileInfo({ fileName: fileName, totalCoupon: coupons.length, fileSize: fileSize })
        };
        reader.readAsBinaryString(f)
    }


    const fileInfoBox = (
        <Box component={Paper} elevation={2} sx={{ p: 1 }}>
            <Typography fontWeight={650} color={green[300]} variant='subtitle1' gutterBottom align='center'>
                File Name : {fileInfo.fileName}
            </Typography>
            <Typography fontWeight={650} color={green[300]} variant='subtitle1' gutterBottom align='center'>
                File Size  : {(fileInfo.fileSize / 1024).toFixed(2)} kb
            </Typography>
            <Typography fontWeight={650} color={green[300]} variant='subtitle1' gutterBottom align='center'>
                Total coupons  : {fileInfo.totalCoupon}
            </Typography>
        </Box>
    )

    const userFileUpload = (
        <Card sx={{ width: '100%', mt: 2, mr: 2, pr: 2 }}>
            <Typography sx={{m : 1}} fontWeight={450} variant='h6'>Column : [Coupon] </Typography>
            {
                coupons.length > 0 ?
                    fileInfoBox : <Skeleton variant="rectangular" width={'100%'} height={218} />
            }
            <CardActions disableSpacing>
                <label htmlFor="subject-banner">
                    <Input onChange={onUploadExcel} accept="*" id="subject-banner" type="file" />
                    <Button component="span" size="small">Upload Excel</Button>
                </label>
            </CardActions>
        </Card>
    )

    const form = (
        <Paper variant="outlined" sx={{ m: 2, p: 2, width: { md: 400, xs: 300 } }} square>
            <Grid
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
                spacing={'4'}
            >
                <FormControl fullWidth sx={{ m: 1 }}>
                    {userFileUpload}
                    <Button onClick={handleSubmit} sx={{ w: '100%', color: 'green', mt: 2, mr: 2, color: 'white' }} variant="contained">Submit</Button>
                </FormControl>
            </Grid>
        </Paper>
    )
    
    return (
        <React.Fragment>
            <Box sx={{ p: 2, mb: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }} component={Paper} elevation={4}>
                <Typography fontWeight={800} variant='h5' gutterBottom align='center'>Bulk coupon delete</Typography>
                {form}

                {rejectedCoupon?.length > 0 &&
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    sx={{mt : 4 }}
                >
                    <Typography sx={{ color: 'red' }} fontWeight={800} variant='h5' gutterBottom align='center'>
                        Rejected coupon list
                    </Typography>
                    <Grid item md={12}>
                      <RejectedCouponExportToExcel rejectedCoupon={rejectedCoupon} />
                    </Grid>
                </Grid>
            }
            </Box>
        </React.Fragment>
    )
}
